import React from "react";
import BaseMarketoForm from "@qlik/gatsby-plugins/gatsby-plugin-marketo/marketoForm/MarketoForm";
import * as styles from "./MarketoForm.module.css";

const MarketoForm = (props) => <BaseMarketoForm {...props} className={styles.defaultMarketo} />;

export default MarketoForm;
